import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Preloader from '../components/Preloader';
import Modal from '../components/Modal';
import ManageTasksDialog from '../components/ManageTasksDialog';
import { loadUsers } from '../actions/userActions';
import { removeTask, loadTasksFinished, addTask } from '../actions/tasksActions';

class ManageUsersTasks extends Component {
	state = {
		activeUserId: null,
		isModalOpened: false
	}
	
	componentWillMount () {
		this.props.loadUsers();
	}

	closeModal = () => {
		this.setState({
			isModalOpened: false,
			activeUserId: null
		});
	}

	openModal = e => {
		const activeUserId = e.target.dataset.id;

		this.setState({
			isModalOpened: true,
			activeUserId
		});
	}

	render () {
		const { loading, users, tasks } = this.props;
		const { activeUserId, isModalOpened } = this.state;

		return (
			<div className="container">
				{
					loading ?
						<Preloader /> :
						<div>
							<h3 className="text-center">Редактирование и добавление задач</h3>
							<table className="table table-bordered users-list">
								<tbody>
									{
										users.map((user, key) => <tr key={key}>
											<td className="col-xs-1">{key+1}.</td>
											<td className="col-xs-8">
												{user.fio}
											</td>
											<td className="col-xs-3">
												<button className="btn btn-info" onClick={this.openModal} data-id={user.id}>Задачи</button>
											</td>
										</tr>)
									}
								</tbody>
							</table>
							<Modal isOpened={isModalOpened} onCloseClick={this.closeModal}>
								{
									activeUserId ?
										<ManageTasksDialog
											list={tasks.filter(task => task.user_id == activeUserId)}
											name={users.find(user => user.id == activeUserId).name}
											onRemove={this.props.removeTask}
											onAdd={this.props.addTask}
											loadTasksFinished={this.props.loadTasksFinished}
											loading={loading}
											userId={activeUserId}
										/> : null
								}
							</Modal>
						</div>
				}
			</div>
		);
	}
}

ManageUsersTasks.propTypes = {
	loading: PropTypes.bool,
	loadTasksFinished: PropTypes.func,
	removeTask: PropTypes.func,
	addTask: PropTypes.func,
	loadUsers: PropTypes.func,
	users: PropTypes.array,
	tasks: PropTypes.array
};

const mapStateToProps = state => ({
	users: state.users.list,
	tasks: state.tasks.actual.concat(state.tasks.finished),
	loading: state.users.loading || state.tasks.loading
});

const mapDispatchToProps = dispatch => ({
	loadUsers: () => dispatch(loadUsers()),
	removeTask: id => dispatch(removeTask(id)),
	loadTasksFinished: () => dispatch(loadTasksFinished()),
	addTask: data => dispatch(addTask(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsersTasks);



// WEBPACK FOOTER //
// ./containers/ManageUsersTasks.js